module.exports = __webpack_public_path__ + "img/rocha-e-medeiros.2ede4dcc.webp";